/**
 * Authorization is not ordinary app data. A cached denial is worse than a little extra traffic because it hides
 * controls the user now owns until they hard-refresh. Keep the permission graph immediately stale so mounting a
 * scoped route always asks the backend again.
 */
export const AUTHORIZATION_SYNC_STALE_TIME_MS = 0

/** Query policy for the authoritative tenant bootstrap/permission graph. */
export const AUTHORIZATION_SYNC_QUERY_OPTIONS = {
  staleTime: AUTHORIZATION_SYNC_STALE_TIME_MS,
  refetchOnMount: "always",
  refetchInterval: false,
  refetchOnWindowFocus: "always",
  refetchOnReconnect: "always",
} as const
